(() => {
  'use strict';
  function previewHref(href, origin, id, role) {
    if (!href || href.startsWith('#') || role === 'main' || !id) return href;
    let url;
    try { url = new URL(href, origin); } catch { return href; }
    if (url.origin !== origin || !['http:', 'https:'].includes(url.protocol) || /^\/(?:checkouts?|account|customer_authentication|challenge|apps)(?:\/|$)/.test(url.pathname)) return href;
    url.searchParams.set('preview_theme_id', String(id));
    return url.pathname + url.search + url.hash;
  }
  if (typeof module !== 'undefined') module.exports = {previewHref};
  if (typeof document === 'undefined') return;
  const apply = node => {
    const theme = window.Shopify?.theme;
    if (!theme || theme.role === 'main') return;
    const links = node.matches?.('a[href]') ? [node] : node.querySelectorAll?.('a[href]') || [];
    for (const link of links) {
      const before = link.getAttribute('href');
      const after = previewHref(before, window.location.origin, theme.id, theme.role);
      if (after !== before) link.setAttribute('href', after);
    }
    const search = document.querySelector('.v3-header-shell form.search');
    if (search && !search.elements.preview_theme_id) {
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = 'preview_theme_id'; input.value = String(theme.id);
      search.append(input);
    }
  };
  apply(document);
  const drawer=document.querySelector('.v3-header-shell [data-mobile-drawer]');
  drawer?.addEventListener('click',event=>{
    const link=event.target.closest('a[href^="#sv5-"]');
    if(link&&drawer.classList.contains('open'))drawer.querySelector('[data-menu-close]')?.click();
  });
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) apply(node);
  }).observe(document.body, {childList: true, subtree: true});
})();
